// extracted by mini-css-extract-plugin
export var fadeIn = "_jn-1";
export var modalContent = "_jn-3";
export var overlay = "_jn-0";
export var popoverContent = "_jn-2";
export var results = "_jn-5";
export var searchInputWrapper = "_jn-4";